module.exports = __webpack_public_path__ + "img/edu-institution-5.d3e3f73a.png";